import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { categoryService } from '../services';
import type { Category } from '../types/Product';

const Categories: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        setIsLoading(true);
        const response = await categoryService.getCategories();
        if (response.success && response.data) {
          setCategories(response.data);
        }
      } catch {
        console.error('Error occurred loading categories');
      } finally {
        setIsLoading(false);
      }
    };
    loadCategories();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-neutral-900 mb-4">All Categories</h1>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
            Browse our complete collection of fireworks and firecrackers
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
            >
              <div className="aspect-square bg-gradient-to-br from-neutral-100 to-neutral-50 p-8 flex items-center justify-center">
                {category.image ? (
                  <img 
                    src={category.image} 
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="text-6xl group-hover:animate-bounce-soft transition-all duration-300">
                    🎆
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-accent-600 transition-colors duration-300">
                  {category.name}
                </h3>
                <p className="text-sm text-neutral-600 mt-2">
                  View all {category.name.toLowerCase()}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {categories.length === 0 && (
          <div className="text-center py-12">
            <p className="text-lg text-neutral-600">No categories found.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Categories;